import { LoginOption, ProfileKey } from './visor.types';

export const PROFILE_ICON_PATHS: Record<ProfileKey, string> = {
  public: '/profile-icons/public.png',
  irrigators: '/profile-icons/regante.png',
  guards: '/profile-icons/guarda.png',
  managers: '/profile-icons/gestor.png'
};

export const PROFILE_THUMBNAIL_PATHS: Record<ProfileKey, string> = {
  public: '/profile-icons/thumbs/public-48.png',
  irrigators: '/profile-icons/thumbs/regante-48.png',
  guards: '/profile-icons/thumbs/guarda-48.png',
  managers: '/profile-icons/thumbs/gestor-48.png'
};

export const LOGIN_OPTIONS: LoginOption[] = [
  {
    key: 'irrigators',
    title: 'Comuneros',
    subtitle: 'Gestión de sus parcelas y riegos',
    accessTitle: 'Comunero',
    accessSubtitle: 'Mi cuenta'
  },
  {
    key: 'guards',
    title: 'Guardas',
    subtitle: 'Control operativo del municipio',
    accessTitle: 'Guarda RAM',
    accessSubtitle: 'Guarda'
  },
  {
    key: 'managers',
    title: 'Gestores',
    subtitle: 'Gestión completa del sistema',
    accessTitle: 'Gestor RAM',
    accessSubtitle: 'Gestor'
  }
];
